<script>
    import { Radar } from 'vue-chartjs';

    export default {
        extends: Radar,

        props: {
            organisation: {
                type: String,
                required: true,
            },
            items: {
                type: Array,
                required: true,
            },
        },

        computed: {
            radar: vm => ({
                labels: vm.items.map(item => item.frameworkCategory.title),
                datasets: [
                    {
                        label: 'Benchmark',
                        backgroundColor: 'rgba(229,229,229,.4)',
                        borderColor: 'rgba(229,229,229,1)',
                        pointRadius: 3,
                        pointBackgroundColor: 'rgba(229,229,229,1)',
                        pointBorderColor: '#fff',
                        data: vm.items.map(
                            item => item.averageScorePercentage,
                        ),
                    },
                    {
                        label: vm.organisation,
                        backgroundColor: 'rgba(242,135,126,.4)',
                        borderColor: 'rgba(242,135,126,1)',
                        pointRadius: 3,
                        pointBackgroundColor: 'rgba(242,135,126,1)',
                        pointBorderColor: '#fff',
                        data: vm.items.map(
                            item => Math.round((100 / item.totalScorePossible) * item.score),
                        ),
                    },
                ],
            }),
        },

        mounted() {
            this.renderChart(
                this.radar,
                {
                    tooltips: {
                        callbacks: {
                            title: (tooltipItem, data) => data.labels[tooltipItem[0].index],
                            label: (tooltipItem, data) => `${data.datasets[tooltipItem.datasetIndex].label}: ${tooltipItem.yLabel}%`,
                        },
                    },
                    scale: {
                        ticks: {
                            min: 0,
                            max: 100,
                            stepSize: 10,
                        },
                    },
                },
            );
        },
    };
</script>
